define( function() {

	// Match a standalone tag
	return ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/core/var/rsingleTag.js
// module id = 845
// module chunks = 2